import React, { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';


import SessionePage from './pages/SessionePage';
import LoginPage from './pages/LoginPage';
import Nav from './components/Nav';
import ListaEsercizi from './pages/ListaEsercizi';
import ListaSessioni from './pages/ListaSessioni';
import EsercizioPage from './pages/EsercizioPage';
import EsercizioPageV from './pages/EsercizioPageV';
import SessionePageV from './pages/SessionePageV';
import ListaUtenti from './pages/ListaUtenti';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GestionePrivacy from './pages/GestionePrivacy';
import TermsAndConditions from './pages/TermsAndConditions';
import { deleteCookie, getCookie, setCookie } from './services/cookies';
import { Refresh } from '@mui/icons-material';

const drawerWidth = 0;

export default function App() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  //const [token, setToken] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [userName, setUserName] = useState<string>("");
  const location = useLocation();
  const navigate = useNavigate();
  const [host, setHost] = useState<string>("");


  useEffect(() => {
    setHost(window.location.hostname)
  }, [navigate]);

//  useEffect(() => {
//    const savedToken = getCookie('auth_token');
//    if (savedToken) {
//      setToken(savedToken);
//    }
//    const handleBeforeUnload = () => {
//
//      if (token) {
//        setCookie('auth_token', token, 1);
//        console.log("Token salvato nei cookie prima del refresh");
//      }
//    };
//    window.addEventListener('beforeunload', handleBeforeUnload);
//    return () => {
//      window.removeEventListener('beforeunload', handleBeforeUnload);
//    };
//  }, [token]);
//
//
//  if (token ===getCookie('auth_token')){
//    deleteCookie('auth_token');
//  }
//
//  if (!token) {
//    return <LoginPage setToken={setToken} setUserName={setUserName} />;
//  }

  const isPublic = () => {
    // return ['/privacypolicy', '/termsandconditions', '/gestioneprivacy'].includes(location.pathname);
    return host == process.env.REACT_APP_LEGAL_URL
  }

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch('/api/v0/profile', {
          method: 'GET',
          credentials: 'include',
        });
        if (res.status === 200) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch {
        setIsAuthenticated(false);
      }
    };
    if(!isPublic()){
      checkAuth();
    }
  }, []);

  if(host=="" || (host!=process.env.REACT_APP_BASE_URL && host!=process.env.REACT_APP_LEGAL_URL)){
    return(<></>)
  }

  return (
    isPublic() ? (
      <Routes>
        <Route path="/privacypolicy" element={(<PrivacyPolicy />)} />
        <Route path="/termsandconditions" element={(<TermsAndConditions />)} />
        <Route path="/gestioneprivacy" element={(<GestionePrivacy />)} />
      </Routes>
    ) : (
      isAuthenticated==null ? (<></>) :
      !isAuthenticated ? (
        <LoginPage onLogin={() => setIsAuthenticated(true)} setUserName={setUserName} />
      ) : (
        <Box sx={{ display: "flex", width: "100vw",height:"100vh"}}>
          <Nav isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} userName={userName} onLogout={() => setIsAuthenticated(false)}/>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              transition: "margin 1.3s ease",
              overflow: "hidden",
              overflowY: "hidden",
              marginLeft: isNavOpen ? `${drawerWidth}px` : "0px",
            }}
          >
            <Routes>
              <Route path="/" element={isAuthenticated ? (<ListaEsercizi />) : <Navigate to="/login" replace />} />
              <Route path="/esercizi" element={isAuthenticated ? (<ListaEsercizi />) : <Navigate to="/login" replace />} />
              <Route path="/esercizi/:id" element={isAuthenticated ? (<EsercizioPageV />) : <Navigate to="/login" replace />} />
              <Route path="/esercizi/new/edit" element={isAuthenticated ? (<EsercizioPage />) : <Navigate to="/login" replace />} />
              <Route path="/esercizi/:id/edit" element={isAuthenticated ? (<EsercizioPage />) : <Navigate to="/login" replace />} />
              <Route path="/sessioni" element={isAuthenticated ? (<ListaSessioni />) : <Navigate to="/login" replace />} />
              <Route path="/sessioni/new/edit" element={isAuthenticated ? (<SessionePage />) : <Navigate to="/login" replace />} />
              <Route path="/sessioni/:id" element={isAuthenticated ? (<SessionePageV />) : <Navigate to="/login" replace />} />
              <Route path="/sessioni/:id/edit" element={isAuthenticated ? (<SessionePage />) : <Navigate to="/login" replace />} />
              {/*<Route path="/programmi" element={isAuthenticated ? (<></>) : <Navigate to="/login" replace />} />*/}
              <Route path="/utenze" element={isAuthenticated ? (<ListaUtenti />) : <Navigate to="/login" replace />} />
            </Routes>
          </Box>
        </Box>
      )
    )
  );
}
